import { render, staticRenderFns } from "./feedbackType.vue?vue&type=template&id=7ad5084f&scoped=true&"
import script from "./feedbackType.vue?vue&type=script&lang=js&"
export * from "./feedbackType.vue?vue&type=script&lang=js&"
import style0 from "./feedbackType.vue?vue&type=style&index=0&id=7ad5084f&prod&lang=scss&scoped=true&"
import style1 from "./feedbackType.vue?vue&type=style&index=1&id=7ad5084f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad5084f",
  null
  
)

export default component.exports